const useInitial = () => {
    return {
        preferences: {},
        isLoaded: true,
    };
};
export default useInitial;
